import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Icon({ children, ...props }: IconProps): React.JSX.Element {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" {...props}>
            {children}
        </svg>
    );
}

export function GridIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
        </Icon>
    );
}

export function RackIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <rect x="5" y="2.5" width="14" height="19" rx="1.5" />
            <path d="M8 6h8M8 10h8M8 14h8M8 18h8" />
        </Icon>
    );
}

export function BoxIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="m4 7 8-4 8 4-8 4-8-4Z" />
            <path d="m4 7 8 4 8-4v10l-8 4-8-4V7Z" />
            <path d="M12 11v10" />
        </Icon>
    );
}

export function FolderIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M3 6.5h7l2 2h9v10.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5Z" />
            <path d="M3 6.5v-2h7l2 2" />
        </Icon>
    );
}

export function LockIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <rect x="5" y="10" width="14" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </Icon>
    );
}

export function UndoIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="m9 7-5 5 5 5" />
            <path d="M4 12h9a7 7 0 0 1 7 7" />
        </Icon>
    );
}

export function RedoIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="m15 7 5 5-5 5" />
            <path d="M20 12h-9a7 7 0 0 0-7 7" />
        </Icon>
    );
}

export function DownloadIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M12 3v12m0 0 5-5m-5 5-5-5" />
            <path d="M4 19h16" />
        </Icon>
    );
}

export function UploadIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M12 16V4m0 0 5 5m-5-5L7 9" />
            <path d="M4 20h16" />
        </Icon>
    );
}

export function PlusIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M12 5v14M5 12h14" />
        </Icon>
    );
}

export function SearchIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-4-4" />
        </Icon>
    );
}

export function TrashIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M4 7h16M9 7V4h6v3m3 0-1 14H7L6 7" />
            <path d="M10 11v6m4-6v6" />
        </Icon>
    );
}

export function CopyIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <rect x="8" y="8" width="12" height="12" rx="2" />
            <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
        </Icon>
    );
}

export function EditIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="m4 20 4.5-1 10-10-3.5-3.5-10 10L4 20Z" />
            <path d="m13.5 7 3.5 3.5" />
        </Icon>
    );
}

export function SettingsIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.86 2.86-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1.1V21H9.55v-.08A1.7 1.7 0 0 0 8.4 19.4a1.7 1.7 0 0 0-1.88.34l-.06.06-2.86-2.86.06-.06A1.7 1.7 0 0 0 4 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1.1-.4H2V9.55h.08A1.7 1.7 0 0 0 4 8.4a1.7 1.7 0 0 0-.34-1.88l-.06-.06L6.46 3.6l.06.06A1.7 1.7 0 0 0 8.4 4a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1.1V2h4.05v.08A1.7 1.7 0 0 0 15 4a1.7 1.7 0 0 0 1.88-.34l.06-.06 2.86 2.86-.06.06A1.7 1.7 0 0 0 19.4 8.4c.2.4.56.75 1 .95.34.16.72.23 1.1.2h.08v4.05h-.08a1.7 1.7 0 0 0-2.1 1.4Z" />
        </Icon>
    );
}

export function ChevronDownIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="m7 9.5 5 5 5-5" />
        </Icon>
    );
}

export function SignOutIcon(props: IconProps): React.JSX.Element {
    return (
        <Icon {...props}>
            <path d="M10 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5" />
            <path d="m15 8 4 4-4 4M19 12H9" />
        </Icon>
    );
}
